const links = document.querySelectorAll('.collection-edits__link');
const contents = document.querySelectorAll('.collection-edits__content');

links.forEach(link => {
  link.addEventListener('click', () => {
    const collectionId = link.dataset.collectionId;

    // Update button styles for all links
    links.forEach(l => {
      l.classList.remove('button--primary');
      l.classList.add('button-secondary');
    });
    contents.forEach(c => c.classList.remove('is-active'));

    // Set clicked link as primary and show matching content
    link.classList.remove('button-secondary');
    link.classList.add('button--primary');
    const content = document.querySelector(`[data-collection-content="${collectionId}"]`);
    if (content) {
      content.classList.add('is-active');
    }
  });
});
